import ApiService from '@/common/api.service'
import ErrorsService from './errors.service'
import { REGISTER, REGISTER_RESET, REGISTER_CONFIRM, CHECK_UID } from './actions.type'
import { SET_REGISTER_DEFAULT, SET_REGISTER, SET_REGISTER_ERRORS, SET_REGISTER_LOADING, SET_REGISTER_CONFIRM, SET_REGISTER_CONFIRM_ERRORS, SET_REGISTER_CONFIRM_LOADING, SET_CHECK_UID, SET_CHECK_UID_ERRORS, SET_CHECK_UID_LOADING } from './mutations.type'

const state = {
	registerErrors: [],
	registerIsLoading: false,
	registerConfirmErrors: [],
	registerConfirmIsLoading: false,
	checkUidErrors: [],
	checkUidIsLoading: false
}

const getters = {
	registerErrors (state) {
		return state.registerErrors
	},
	registerIsLoading (state) {
		return state.registerIsLoading
	},
	registerConfirmErrors (state) {
		return state.registerConfirmErrors
	},
	registerConfirmIsLoading (state) {
		return state.registerConfirmIsLoading
	},
	checkUidErrors (state) {
		return state.checkUidErrors
	},
	checkUidIsLoading (state) {
		return state.checkUidIsLoading
	}
}

const actions = {
	[REGISTER] (context, params) {
		context.commit(SET_REGISTER_LOADING)
		return new Promise((resolve, reject) => {
			ApiService.post(REGISTER, params)
			.then(({data}) => {
				context.commit(SET_REGISTER)
				resolve(data)
			})
			.catch((error) => {
				ErrorsService.setFetchError(SET_REGISTER_ERRORS, context, error)
				resolve(false)
			})
			.finally(x => {
				context.commit(SET_REGISTER_LOADING, false)
			})
		})
	},
	[REGISTER_RESET] (context, params) {
		context.commit(SET_REGISTER_DEFAULT)
	},
	[CHECK_UID] (context, params) {
		context.commit(SET_CHECK_UID_LOADING)
		return new Promise((resolve, reject) => {
			ApiService.getBy(CHECK_UID, params)
			.then(({data}) => {
				context.commit(SET_CHECK_UID)
				resolve(data)
			})
			.catch((error) => {
				ErrorsService.setFetchError(SET_CHECK_UID_ERRORS, context, error)
				resolve(false)
			})
			.finally(x => {
				context.commit(SET_CHECK_UID_LOADING, false)
			})
		})
	},
	[REGISTER_CONFIRM] (context, params) {
		context.commit(SET_REGISTER_CONFIRM_LOADING)
		return new Promise((resolve, reject) => {
			ApiService.post(REGISTER_CONFIRM, params)
			.then(({data}) => {
				context.commit(SET_REGISTER_CONFIRM)
				resolve(data)	
			})
			.catch((error) => {
				ErrorsService.setFetchError(SET_REGISTER_CONFIRM_ERRORS, context, error)
				resolve(false)
			})
			.finally(x => {
				context.commit(SET_REGISTER_CONFIRM_LOADING, false)
			})
		})
	}
}

const mutations = {
	[SET_REGISTER_DEFAULT] (state) {
		state.registerErrors = []
		state.registerIsLoading = false
		state.registerConfirmErrors = []
		state.registerConfirmIsLoading = false
		state.checkUidErrors = []
		state.checkUidIsLoading = false
	},
	[SET_REGISTER] (state) {
		state.registerErrors = []
	},
	[SET_REGISTER_ERRORS] (state, errors) {
		state.registerErrors = errors
	},
	[SET_REGISTER_LOADING] (state, status = true) {
		state.registerIsLoading = status
	},
	[SET_REGISTER_CONFIRM] (state) {
		state.registerConfirmErrors = []
	},
	[SET_REGISTER_CONFIRM_ERRORS] (state, errors) {
		state.registerConfirmErrors = errors
	},
	[SET_REGISTER_CONFIRM_LOADING] (state, status = true) {
		state.registerConfirmIsLoading = status
	},
	[SET_CHECK_UID] (state) {
		state.checkUidErrors = []
	},
	[SET_CHECK_UID_ERRORS] (state, errors) {
		state.checkUidErrors = errors
	},
	[SET_CHECK_UID_LOADING] (state, status = true) {
		state.checkUidIsLoading = status
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}


// WEBPACK FOOTER //
// ./src/store/register.module.js